// shared/ui/PillButton.jsx  (botón outline redondeado, mismo look que BtnSecundario de ListToolbar)
import React from 'react';
import { OPACIDAD_DESHABILITADO } from './opacidad';

const PillButton = ({ onClick, children, icon, disabled = false, title, danger = false, style }) => (
  <button
    type="button"
    className="btn btn-outline-secondary btn-sirio"
    onClick={onClick}
    disabled={disabled}
    title={title}
    style={{
      borderRadius: 20,
      fontSize: 14,
      lineHeight: '24px',
      opacity: disabled ? OPACIDAD_DESHABILITADO : 1,
      ...(danger ? { borderColor: 'red', color: 'red' } : {}),
      ...style,
    }}>
    {icon && <i className={`fa ${icon} pr-2`} />}
    {children}
  </button>
);

export default PillButton;
